import {Pipe, PipeTransform} from '@angular/core';
import {FileFormatService} from "./file-format.service";

@Pipe({
    name: 'fileIcon'
})
export class FileIconPipe implements PipeTransform {

    constructor(private formatService: FileFormatService) {

    }

    transform(name: string): string {
        return this.formatService.getUrlByName(name);
    }

}
